import axios from "axios";

export const listTemplates = (cursor, limit, success, failure) => {
    let url = "/api/v1/template/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const createTemplate = (template, success, failure) => {
    const url = `/api/v1/template/`;

    axios.post(url, {
        name: template.name,
        content: template.content,
        order: template.order,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const updateTemplate = (templateId, template, success, failure) => {
    const url = `/api/v1/template/${templateId}/`;

    axios.put(url, {
        name: template.name,
        content: template.content,
        order: template.order,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const cloneTemplate = (templateId, success, failure) => {
    const url = `/api/v1/template/${templateId}/`;

    axios.post(url)
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const deleteTemplate = (templateId, success, failure) => {
    const url = `/api/v1/template/${templateId}/`;

    axios.delete(url)
        .then(response => {
            success(templateId);
        })
        .catch(err => {
            failure(err);
        });
};
